import { SharedConstants } from "../../../shared/constants/shared.constants";
export const PAGE_HEADING = "Organisation users";
export const IS_ADMIN_TEXT = "Unable to suspend a system admin.";
export const USER_ALREADY_SUSPENDED_TEXT = `User ${SharedConstants.ITEM_ALREADY_SUSPENDED_LABEL}`;
export const USER_IS_NOT_SUSPENDED_TEXT = `User ${SharedConstants.ITEM_NOT_SUSPENDED_LABEL}`;
export const REMOVE_TITLE_TEXT = `${SharedConstants.REMOVE_TITLE} user`;
export const SUSPEND_USER_TITLE_TEXT = `${SharedConstants.SUSPEND_LABEL} user`;
export const REINSTATE_USER_TITLE_TEXT = `${SharedConstants.REINSTATE_LABEL} user`;
export const REMOVE_CONTENT_TEXT = `${SharedConstants.REMOVE_MESSAGE} user(s)?`;
export const SUSPEND_USER_CONTENT_TEXT = `${SharedConstants.SUSPEND_MESSAGE} user?`;
export const UNSUSPEND_USER_CONTENT_TEXT = `${SharedConstants.UNSUSPEND_MESSAGE} user?`;
export const DELETE_SUCCESS_TEXT = SharedConstants.REMOVE_SUCCESS;
export const SUSPEND_SUCCESS_TEXT = SharedConstants.SUSPEND_SUCCESS;
export const UNSUSPEND_SUCCESS_TEXT = SharedConstants.REINSTATE_SUCCESS;
export const REMOVE_BUTTON_LABEL = SharedConstants.DELETE_LABEL;
export const SUSPEND_BUTTON_LABEL = SharedConstants.SUSPEND_LABEL;
export const REINSTATE_BUTTON_LABEL = SharedConstants.REINSTATE_LABEL;
export const ASSIGN_BUTTON_LABEL = "Assign roles";
export const SERVER_ERROR_OBJECT_NAME = "Organisation";
export var SuspendedEnum;
(function (SuspendedEnum) {
    SuspendedEnum["Yes"] = "Yes";
    SuspendedEnum["No"] = "No";
})(SuspendedEnum || (SuspendedEnum = {}));
